<div class="about-wrapper">

  <div class="photo-header text-center flex items-center"
    style="background-image: url(../assets/img/about/about-hero-bg.jpg)">

    <div class="mx-auto">

      <h1 class="uppercase text-white font-display font-normal photo-header__headline">
        <a href="javascript:void(0)" class="no-underline text-white">About Us</a>
      </h1>

    </div>

  </div>
  <!--/photo-header-->

  <div class="mx-auto my-12 lg:my-20 container container-padding">

    <div class="max-w-lg mx-auto lg:text-center mb-12 lg:mb-20">

      <h2 class="uppercase lg:text-center text-5xl font-display lines-left-red lg-lines-centered-red font-medium">
        <a href="javascript:void(0)" class="no-underline text-black">Our Purpose</a>
      </h2>

      <h3 class="mt-3">
        <a href="javascript:void(0)" class="no-underline text-black"><strong class="text-lg">Tools and Inspiration for Craftsmen</strong></a>
      </h3>
      <p class="mt-0">It’s our mission to help builders, makers,
        craftsmen, DIYers with their projects - Boats, woodworking, home restoration, art. Great products, quick
        delivery, tech help, sweet website,
        videos, howtos and kits ... whatever we can do to help. We’re there for you every step of the way, from
        the moment you need something until after the box is opened. Straight through until the project is
      completed. </p>

    </div>

  </div>

  <div class="bg-grey-lighter">

    <div class="container container-padding mx-auto py-10 md:py-16">

      <div class="mx-auto">

        <h2 class="lg:text-center uppercase text-30px font-display lines-left-red lg-lines-centered-red mb-8 font-medium">
          <a href="javascript:void(0)" class="no-underline text-black">JD CORE VALUES</a>
        </h2>

        <div class="md:flex flex-wrap lg:flex-no-wrap items-start">

          <div class="md:w-1/3 lg:w-1/5 mb-8 pr-6">
            <a href="javascript:void(0)" class="no-underline text-black">
              <h3 class="text-base"><strong class="lg-text">Make it Simple</strong></h3>
            </a>
            Strive to make things as simple as possible. Systems,
            processes, emails, products, explanations, descriptions in the catalog and on website. Only
            great products, no junk. Make it simpler
            for your coworkers and your customers.
          </div>

          <div class="md:w-1/3 lg:w-1/5 mb-8 pr-6">
            <a href="javascript:void(0)" class="no-underline text-black">
              <h3 class="text-base"><strong class="lg-text">Listen to Customers</strong></h3>
            </a>
            If we satisfy our customers needs, if we make our
            customers happy, we will continue to grow. What do our customers want?
          </div>

          <div class="md:w-1/3 lg:w-1/5 mb-8 pr-6">
            <a href="javascript:void(0)" class="no-underline text-black">
              <h3 class="text-base"><strong class="lg-text">Continuously Improve</strong></h3>
            </a>
            Strive to be better today than yesterday. What
            can we do to improve? How can we make JD a better place to work? How can we improve our
            products? How can we improve the experience
            for the customer?
          </div>

          <div class="md:w-1/3 lg:w-1/5 mb-8 pr-6">
            <a href="javascript:void(0)" class="no-underline text-black">
              <h3 class="text-base"><strong class="lg-text">Never Say Die</strong></h3>
            </a>
            Don’t give up! Stick with it. Finish a project to the
            end. Go the extra mile.
          </div>

          <div class="md:w-1/3 lg:w-1/5 mb-2 md:mb-8 pr-6">
            <a href="javascript:void(0)" class="no-underline text-black">
              <h3 class="text-base"><strong class="lg-text">Have Fun!</strong></h3>
            </a>
            We spend a lot of time here together. We want to build a
            great team and enterprise, but let's not take ourselves TOO seriously. Lets have some fun!
          </div>

        </div>

      </div>

    </div>

  </div>

  <div class="callout-section callout-section--full-width">

    <div class="mx-auto container container-padding pt-8 pb-12 md:pt-16 lg:flex items-center lg:py-16">

      <div class="lg:w-1/2 pb-8 lg:pb-0 lg:pr-4 xl:pr-8">
        <div class="mb-4">
          <img class="home-callout-section__image" style="width:45rem;" appImageLazyLoad loading="lazy"
            [src]="'../assets/img/about/about-history.jpg'" alt=""/>
          </div>
        </div>

        <div class="lg:w-1/2 lg:pl-4 xl:pl-8 md:flex items-center">
          <div>
            <a href="javascript:void(0)" class="no-underline text-black">
              <h2 class="uppercase text-30px font-display lines-left-red mb-4 md:mb-0 font-medium">About Jamestown & Our History</h2>
            </a>

            <p>Jamestown Distributors is an industry leader in marine and building supplies. We're a family-run
              business based in Bristol, RI - a town with a rich boat building tradition - and have been
              supplying and assisting boaters for over 30
              years. In our 40,000 square foot warehouse we've got everything you need to maintain, restore
              and even build your own craft. The most important thing you'll find, however, is our team of
            boat lovers who really know their stuff.</p>

            <p>We started selling Marine Fasteners to local boat builders and boatyards in 1977. Since then, our
              offering has grown to include marine epoxies, fiberglass and composite materials as well as
              marine paints, hardware and tools. We pride
              ourselves in offering the best selection of marine fasteners available, including everything
              silicon bronze, stainless steel, brass and galvanized. We literally started the business by
              stocking the “hard-to-find fasteners” and
            we are proud to say that is still one of our goals.</p>

            <p>Our success has always been due to the loyalty of our customers. Some of these customers have
              been with us since the beginning, working on the same project even. But, whether it’s your first
              project or your one millionth we want to
              hear from you. Let us know what your latest project is and how we can help. That is what
              Jamestown Distributors is all about.
            </p>

          </div>
        </div>

      </div>

    </div>
    <!--/callout-section-->

    @if (customerQuotes && customerQuotes.length) {
      <div class="slider-dark aboutusSlider bg-none" appBackgroundLazyLoad>
        <div class="pt-12 pb-20 text-center">
          <a href="javascript:void(0)" class="no-underline text-black">
            <h2 class="text-center text-white uppercase text-30px font-display lines-centered-white mb-8 font-medium">What Our Customers Are Saying</h2>
          </a>
          <ngx-slick-carousel class="carousel" #frequentlyPurchasedSlickModal="slick-carousel"
            [config]="frequentlyPurchasedSlideConfig">
            @for (quotes of customerQuotes; track quotes; let i = $index) {
              <div ngxSlickItem
                class="customers-slider circle-dots equalize-children">
                <div class="customers-slider__item text-center px-2">
                  <div class="bg-white rounded-lg py-10 px-4 equalize-heights">
                    <img class="customers-slider__item__quote" appImageLazyLoad loading="lazy"
                      [src]="'../assets/img/about/quote.svg'" alt="">
                      <a href="javascript:void(0)" class="no-underline text-black">
                        <blockquote>
                          <q class="text-sm my-2 block">{{quotes?.quote}}</q>
                        </blockquote>
                      </a>
                      <a href="javascript:void(0)" class="no-underline text-black">
                        <div class="text-22px font-display uppercase opacity-80">— {{quotes?.attribution}}</div>
                      </a>
                    </div>
                  </div>
                </div>
              }
            </ngx-slick-carousel>
          </div>
        </div>
      }

      @if (ourCrew && ourCrew.length) {
        <div class="bg-grey-lighter">
          <div class="container container-padding mx-auto pt-10 md:pt-16">
            <div class="mx-auto">
              <a href="javascript:void(0)" class="no-underline text-black">
                <h2 class="text-center uppercase text-30px font-display lines-centered-red mb-8 font-medium">
                  Our Crew
                </h2>
              </a>
            </div>
          </div>
          <div class="container pb-2 md:pb-10 mx-auto">
            <div class="mx-auto">
              <div class="xl:flex flex-row-reverse crew-list">
                <div class="crew-list__photos">
                  <div class="crew-list__photos__inner">
                    <div class="crew-list__photos__inner__mobile xl:hidden">
                      @for (crew of ourCrew; track crew; let i = $index) {
                        <a (click)="selectCrew(crew)"
                          class="crew-list__photos__item js-crew-selector"
                          [ngClass]="{active: isActive(crew)}">
                          <img [src]="crew?.imageURL" appImageLazyLoad loading="lazy" [alt]="crew?.name">
                          <script type="text/template" class="js-template">
                            <p class="text-base">
                              <a href="javascript:void(0)" class="no-underline text-black">
                                <h3><strong class="text-2xl">{{crew?.name}}</strong></h3>
                              </a>
                              {{crew?.title}}
                            </p>
                            <p>{{crew?.employee}}</p>
                          </script>
                        </a>
                      }
                    </div>
                    <div class="crew-list__photos__inner__desktop hidden xl:block">
                      <div class="crew-list__photos__inner__desktop__slider">
                        <ul role="tablist" class="flex flex-wrap justify-center items-center list-style-none our-crew-img-list">
                          @for (crew of ourCrew; track crew; let i = $index) {
                            <li role="presentation">
                              <a [attr.aria-selected]="isActive(crew)" role="tab" href="javascript:void(0)" [attr.aria-controls]="'tab ' + crew?.name + ' ' + crew?.title" (click)="selectCrew(crew)"
                                class="crew-list__photos__item js-crew-selector focus"
                                [ngClass]="{active: isActive(crew)}">
                                <img [src]="crew?.imageURL" appImageLazyLoad loading="lazy"
                                  [alt]="crew?.name">
                                  <script type="text/template" class="js-template">
                                    <p class="text-base">
                                      <a href="javascript:void(0)" class="no-underline text-black">
                                        <h3><strong class="text-2xl">{{crew?.name}}</strong></h3>
                                      </a>
                                      {{crew?.title}}
                                    </p>
                                    <p>{{crew?.employeeCopy}}</p>
                                  </script>
                                </a>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div [id]="'tab ' + selectedCrew?.name + ' ' + selectedCrew?.title" role="tabpanel" class="xl:flex flex-wrap px-5 crew-list__bio-wrapper">
                    <div class="crew-list__bio py-1 lg:pr-6 pb-2 text-sm rounded-lg js-crew-bio">
                      <a href="javascript:void(0)" class="no-underline text-black">
                        <h3 class="mt-3"><strong class="text-2xl">{{selectedCrew?.name}}</strong></h3>
                      </a>
                      <p class="text-base mt-0">
                        {{selectedCrew?.title}}
                      </p>
                      <p [innerHTML]="selectedCrew?.employeeCopy | safeHtml:'html'"> </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="callout-section callout-section--full-width">

          <div
            class="mx-auto container container-padding pt-4 md:pt-20 pb-8 md:pb-12 md:flex items-center md:flex-row-reverse lg:py-20">

            <div class="md:w-1/2 md:pl-4 lg:pl-8">
              <div class="mb-4">
                <img class="home-callout-section__image" appImageLazyLoad loading="lazy"
                  [src]="'../assets/img/about/job.jpg'" alt="" />
                </div>
              </div>

              <div class="md:w-1/2 md:pr-4 lg:pr-8 md:flex items-center">
                <div>
                  <a href="javascript:void(0)" class="no-underline text-black">
                    <h2 class="uppercase text-30px font-display lines-left-red mb-4 md:mb-0 font-medium">Want a job you’ll love?</h2>
                  </a>

                  <p>Come join the team. Jamestown's offices and warehouse are a friendly, fun and professional
                    environment. We offer employee discounts, a casual work environment and a competitive benefits
                  package.</p>

                  <a [href]="jobsLink" target="_blank"
                    class="inline-block mt-4 md:mt-8 button button--small button--border w-full md:w-auto">See
                  Opportunities</a>
                </div>
              </div>

            </div>

          </div>
          <!--/callout-section-->

          <div class="callout-section callout-section--full-width">

            <div
              class="mx-auto container container-padding pb-12 flex flex-col-reverse md:items-center md:flex-row lg:pb-20">

              <div class="md:w-1/2 md:pr-4 lg:pr-8">
                <ul class="my-4 flex flex-wrap justify-center items-center organization-logos">
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/GKR.svg'" alt="Good Karma Racing Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/providence_CB.svg'" alt="Community Boating Center INDIA POINT PARK PROVIDENCE Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/nh_boat_museum.svg'" alt="BOAT MUSEUM Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/IYRS_logo.svg'" alt="IYRS Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/EBSF.svg'" alt="EBSF Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/OHPnew.svg'" alt="OLIVER HAZARD PERRY Education at Sea Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/save_the_children.svg'" alt="Save The Children Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/rocking_boat.svg'" alt="Rocking Boat Logo" loading="lazy">
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <img appImageLazyLoad [src]="'../assets/img/about/logos/scout.svg'" alt="Scout Transatlantic Logo" loading="lazy">
                    </a>
                  </li>
                </ul>
              </div>

              <div class="md:w-1/2 md:pl-4 lg:pl-8 md:flex items-center">
                <div>
                  <h2 class="uppercase text-30px font-display lines-left-red mb-4 md:mb-0">
                    <a href="javascript:void(0)" class="text-black no-underline font-medium">Organizations we support</a>
                  </h2>
                  <a href="javascript:void(0)" class="text-black no-underline">
                    <div>
                      <p>We like boats -- we like working on them, playing on them and the lifestyle that comes with
                        having a boat. Jamestown Distributors has been helping people with their boats and boatbuilding
                      needs since 1977.</p>

                      <p>We take pride in working on and caring for our boats. In return our boats take us out on the
                      water and become much more than a toy or a material object.</p>

                      <p>At Jamestown, we feel that it is our responsibility to support, foster and encourage this
                        relationship with people and their boats. Over the years we have partnered with a few
                      organizations to meet that goal.</p>
                    </div>
                  </a>

                </div>
              </div>

            </div>

          </div>
          <!--/callout-section-->

          <div class="mx-auto mb-10 container container-padding">

            <div class="bg-grey-lightest rounded-lg p-6 md:py-12 md:pl-16 md:pr-8">

              <div class="lg:flex">

                <div class="lg:w-3/5 lg:pr-8">
                  <a href="javascript:void(0)" class="no-underline text-black">
                    <h2><strong class="text-lg">How to Request a Donation</strong></h2>
                  </a>

                  <p class="text-sm">
                    Jamestown's charitable donations are given to local non-profit organizations that support our
                    mission of supporting Boaters and their Craft.
                    <br>Send requests to <a href="mailto:donationrequests@jamestowndistributors.com"
                    class="emailLink">donationrequests&#64;jamestowndistributors.com</a>
                  </p>
                </div>

                <div class="lg:w-2/5 text-xs">
                  <strong>Please include the following information:</strong>

                  <ul class="mt-4">
                    <li>Proof of 501(c)(3) status</li>
                    <li>Brief overview of the organization</li>
                    <li>Purpose and timeframe of the project</li>
                    <li>Description of the target population and number of people served</li>
                  </ul>
                </div>

              </div>

            </div>

          </div>

          <support-footer></support-footer>

        </div>
        <!--/home-wrapper-->
